import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines clsx and tailwind-merge for cleaner conditional classes
 * without styling conflicts.
 */

const cn = (...args: ClassValue[]) => twMerge(clsx(args))

export default cn
